import { gql } from '@apollo/client';

const GET_PARTNER_TASK_LIST_TEMPLATES = gql`
  query GetPartnerTaskListTemplates($first: Int, $after: String, $id: ID!) {
    viewer {
      id
      __typename
      company {
        id
        __typename
        taskListPartner(id: $id) {
          id
          __typename
          taskListTemplates(first: $first, after: $after) {
            edges {
              cursor
              node {
                id
                name
                description
                isOwner
                owner {
                  ... on PublicTaskListPartner {
                    id
                    name
                    logo
                  }
                }
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      }
    }
  }
`;

export default GET_PARTNER_TASK_LIST_TEMPLATES;
